/** Делает первую букву слова заглавной */
export const capitalizeFirst = (text: string) => text[0].toUpperCase() + text.substring(1);
